// extracted by mini-css-extract-plugin
export var alignCenter = "_8k-d";
export var bannerShown = "_8k-6";
export var buttonContent = "_8k-0";
export var cardList = "_8k-1";
export var centerContent = "_8k-2";
export var chevron = "_8k-3";
export var closePanelButton = "_8k-k";
export var conversationContextContainer = "_8k-l";
export var conversationDetailContainer = "_8k-4";
export var detailWrapper = "_8k-7";
export var dropdownButton = "_8k-e";
export var dropdownTitle = "_8k-9";
export var fullHeight = "_8k-5";
export var hidden = "_8k-a";
export var icon = "_8k-b";
export var mergeSuggestionWrapper = "_8k-m";
export var panel = "_8k-i";
export var portalButtonsWrapper = "_8k-c";
export var right = "_8k-j";
export var tableSummaryContainer = "_8k-8";
export var tableSummaryHeader = "_8k-g";
export var threeDotsButton = "_8k-f";
export var wide = "_8k-h";